import React, { useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { useSelector } from "react-redux";

export default function TinyEditor(props) {
  const { token } = useSelector((state) => state.auth);
  const [error, setError] = useState("");

  if (!Promise.allSettled) {
    Promise.allSettled = function (promises) {
      return Promise.all(
        promises.map((p) =>
          p
            .then((value) => ({
              status: "fulfilled",
              value,
            }))
            .catch((reason) => ({
              status: "rejected",
              reason,
            })),
        ),
      );
    };
  }

  const editorRef = useRef(null);

  function newHandler(blobInfo, success, failure) {
    const formData = new FormData();
    formData.append(
      "operations",
      JSON.stringify({
        query: `
        mutation SaveImage($image: Upload!) {
          saveImage(image: $image)
        }
      `,
        variables: {
          image: null, // file will be mapped below
        },
      }),
    );

    formData.append(
      "map",
      JSON.stringify({
        0: ["variables.image"], // key "0" will be mapped to image
      }),
    );

    formData.append("0", blobInfo.blob(), blobInfo.filename());

    fetch(process.env.REACT_APP_MASTER_DATA, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        const imageUrl = res?.data?.saveImage;

        if (typeof imageUrl === "string" && imageUrl.startsWith("http")) {
          success(imageUrl);

          const editor = editorRef.current;

          const imgs = editor?.dom?.select("img") || [];
          imgs.forEach((img) => {
            if (img.src?.startsWith("blob:")) {
              img.src = imageUrl;
            }
          });
        } else {
          failure("Invalid image URL");
        }
      })
      .catch(() => {
        failure("Upload failed");
      });
  }

  return (
    <Editor
      tinymceScriptSrc="/tinymce/tinymce.min.js"
      licenseKey="gpl"
      className={props?.className}
      disabled={props?.disabled}
      onInit={(_evt, editor) => (editorRef.current = editor)}
      value={props?.value}
      init={{
        height: 500,
        menubar: false,
        plugins: [
          "advlist",
          "autolink",
          "lists",
          "link",
          "image",
          "charmap",
          "anchor",
          "searchreplace",
          "visualblocks",
          "code",
          "fullscreen",
          "insertdatetime",
          "media",
          "table",
          "preview",
          "help",
          "wordcount",
          "autoresize",
        ],
        toolbar:
          "undo redo | link code | formatselect | " +
          "bold italic backcolor forecolor | alignleft aligncenter " +
          "alignright alignjustify | bullist numlist outdent indent | " +
          "removeformat | help",
        content_style:
          "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        images_upload_handler: newHandler,
        automatic_uploads: true,
        // paste_data_images: false, // optional: uncomment if needed
      }}
      onEditorChange={(content, editor) => {
        // Remove all leading &nbsp; from each <p> tag
        const sanitizedContent = content.replace(/<p>(&nbsp;)+/g, "<p>");

        // Check if first visible text starts with space or non-breaking space
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = content;
        const firstParagraph = tempDiv.querySelector("p");
        if (firstParagraph) {
          const text = firstParagraph.textContent || "";
          if (text.startsWith(" ") || text.startsWith("\u00A0")) {
            setError("Content cannot start with a space.");
          } else {
            setError("");
          }
        }

        if (props?.func) {
          props.func(sanitizedContent, editor);
        }
      }}
    />
  );
}
